export default __webpack_public_path__ + "static/Network-Penetration-e5c3dc9f5130e2d4ce8bdeb8414bd755.png";